import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import Realizzazioni from "@/components/site/Realizzazioni";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <main data-testid="home-page" className="bg-[#F4F1EA] text-[#1C1B1A] overflow-x-clip">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Realizzazioni />
      <WhyUs />
      <Contact />
      <Footer />
    </main>
  );
}
